import { render, staticRenderFns } from "./entry-counter.vue?vue&type=template&id=810df364&scoped=true&"
import script from "./entry-counter.vue?vue&type=script&lang=js&"
export * from "./entry-counter.vue?vue&type=script&lang=js&"
import style0 from "./entry-counter.vue?vue&type=style&index=0&id=810df364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810df364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810df364')) {
      api.createRecord('810df364', component.options)
    } else {
      api.reload('810df364', component.options)
    }
    module.hot.accept("./entry-counter.vue?vue&type=template&id=810df364&scoped=true&", function () {
      api.rerender('810df364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/entry-counter.vue"
export default component.exports